export function assignButtonColors(
  response: any[],
  assignments: Array<[number, (color: any) => void]>
): void {
  if (!Array.isArray(response) || !response.length) {
    return;
  }
  assignments.forEach(([button, apply]) => {
    const item = response.find((entry: any) => entry && entry.button == button);
    if (item) {
      apply(item.color);
    }
  });
}
